<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-1">
      <div class="breadcrumb-title border-0 mb-3">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <div class="d-flex align-items-center">
            <i class="bi bi-menu-button-wide text-primary"> </i>
            <p class="ms-2 mb-0">
              {{ applications?.name }}
              {{ "MenListComponent.title" | translate }}
            </p>
          </div>
          <div class="p-0 m-0">
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row align-items-start compact-inputs dropdown-pd-none">
            <!-- Search Input -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "MenListComponent.search.titlePlaceholder" | translate
                }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="form.searchParams['name']"
                  id="name"
                  name="name"
                />
              </mat-form-field>
            </div>

            <!-- Link Type Select -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "MenListComponent.search.typePlaceholder" | translate
                }}</mat-label>
                <mat-select
                  [(ngModel)]="form.searchParams['linkto']"
                  name="linkto"
                >
                  <mat-option value="undefined">{{
                    "MenListComponent.search.typePlaceholder" | translate
                  }}</mat-option>
                  <mat-option value="form">{{
                    "MenListComponent.search.types.form" | translate
                  }}</mat-option>
                  <mat-option value="report">{{
                    "MenListComponent.search.types.report" | translate
                  }}</mat-option>
                  <mat-option value="url">{{
                    "MenListComponent.search.types.url" | translate
                  }}</mat-option>
                  <mat-option value="seperator">{{
                    "MenListComponent.search.types.seperator" | translate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- User Story Select -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "MenListComponent.search.apiPlaceholder" | translate
                }}</mat-label>
                <mat-select
                  [(ngModel)]="form.searchParams['userstoryId']"
                  name="userstoryId"
                  (selectionChange)="
                    convertStrToNumUser(form.searchParams['userstoryId'])
                  "
                >
                  <mat-option value="undefined">{{
                    "MenListComponent.search.apiPlaceholder" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of usecases" [value]="e['id']">{{
                    e["name"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Form Select -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "MenListComponent.search.formPlaceholder" | translate
                }}</mat-label>
                <mat-select
                  [(ngModel)]="form.searchParams['formId']"
                  name="formId"
                  (selectionChange)="
                    convertStrToNumForm(form.searchParams['formId'])
                  "
                >
                  <mat-option value="undefined">{{
                    "MenListComponent.search.formPlaceholder" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of forms" [value]="e['id']">{{
                    e["title"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Report Select -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "MenListComponent.search.reportPlaceholder" | translate
                }}</mat-label>
                <mat-select
                  [(ngModel)]="form.searchParams['reportsId']"
                  name="reportsId"
                >
                  <mat-option value="undefined">{{
                    "MenListComponent.search.reportPlaceholder" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of reportlist" [value]="e['id']">{{
                    e["title"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Action Buttons -->
            <div class="col-auto mb-2">
              <div class="d-flex flex-wrap gap-2">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="searchDataFilter()"
                >
                  <mat-icon>search</mat-icon>
                  <span>
                    {{
                      "MenListComponent.search.buttons.search" | translate
                    }}</span
                  >
                </button>

                <button
                  mat-stroked-button
                  color="warn"
                  (click)="resetSearchForm()"
                >
                  <i class="fa fa-eraser eraser-warn-dark"></i>
                  <span class="ms-2">{{
                    "MenListComponent.search.buttons.reset" | translate
                  }}</span>
                </button>

                <button
                  mat-stroked-button
                  color="primary"
                  (click)="resetForm()"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  <mat-icon>add</mat-icon>
                  {{ "MenListComponent.search.buttons.add" | translate }}
                </button>
                <div>
                  <ul class="nav nav-pills" id="pills-tab" role="tablist">
                    <li
                      class="nav-item"
                      role="presentation"
                      *ngIf="!isProfileTabActive"
                    >
                      <button
                        mat-stroked-button
                        color="primary"
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                        (click)="toggleTab('profile')"
                        class="icon-center icon-width"
                      >
                        <mat-icon
                          class="icon-compact"
                          style="transform: rotate(180deg)"
                          >archive</mat-icon
                        >
                      </button>
                    </li>
                    <li
                      class="nav-item"
                      role="presentation"
                      *ngIf="isProfileTabActive"
                    >
                      <button
                        mat-stroked-button
                        color="primary"
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="true"
                        (click)="toggleTab('home')"
                        class="icon-center icon-clean icon-width"
                      >
                        <mat-icon class="icon-compact">list</mat-icon>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade"
              [class.show]="!isProfileTabActive"
              [class.active]="!isProfileTabActive"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <!-- Bootstrap Tabs with Material styling -->
              <nav class="my-2">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link active material-tab-button"
                    id="nav-details-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-details"
                    type="button"
                    role="tab"
                    aria-controls="nav-details"
                    aria-selected="true"
                  >
                    <mat-icon class="me-1" style="line-height: inherit"
                      >list</mat-icon
                    >
                    {{ "MenListComponent.tabs.addRoleMenuItem" | translate }}
                  </button>
                  <button
                    class="nav-link material-tab-button"
                    id="nav-previews-tab"
                    (click)="resetUnassignlist()"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-new-previews"
                    type="button"
                    role="tab"
                    aria-controls="nav-new-previews"
                    aria-selected="false"
                  >
                    <mat-icon class="me-1" style="line-height: inherit"
                      >menu</mat-icon
                    >
                    {{ "MenListComponent.tabs.roleMenu" | translate }}
                  </button>
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                </p>
                <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                </p>
                <div
                  class="tab-pane fade show active"
                  id="nav-details"
                  role="tabpanel"
                  aria-labelledby="nav-details-tab"
                  tabindex="0"
                >
                  <!-- table form -->
                  <div class="my-3">
                    <p
                      *ngIf="searchMessage"
                      class="alert"
                      [ngClass]="searchError ? 'alert-danger' : 'alert-success'"
                    >
                      {{ searchMessage }}
                      <button
                        type="button"
                        class="close"
                        aria-label="Close"
                        (click)="closeAlert()"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </p>
                    <div class="table-container mb-3">
                      <div class="table-responsive table-scrollable">
                        <table
                          class="table table-bordered table-hover table-sticky-header"
                        >
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{
                                  "MenListComponent.table.headers.sno"
                                    | translate
                                }}
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('title')"
                                >
                                  {{
                                    "MenListComponent.table.headers.title"
                                      | translate
                                  }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'title' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('linkTo')"
                                >
                                  {{
                                    "MenListComponent.table.headers.linkTo"
                                      | translate
                                  }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'linkTo' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('applicationName')"
                                >
                                  {{
                                    "MenListComponent.table.headers.application"
                                      | translate
                                  }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'applicationName' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('formName')"
                                >
                                  {{
                                    "MenListComponent.table.headers.form"
                                      | translate
                                  }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'formName' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('reportName')"
                                >
                                  {{
                                    "MenListComponent.table.headers.report"
                                      | translate
                                  }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'reportName' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th class="text-nowrap sortable-header">
                                <span
                                  class="header-label"
                                  (click)="sortTable('url')"
                                >
                                  {{
                                    "MenListComponent.table.headers.url"
                                      | translate
                                  }}
                                  <ng-container
                                    *ngTemplateOutlet="
                                      sortIcons;
                                      context: { key: 'url' }
                                    "
                                  ></ng-container>
                                </span>
                              </th>

                              <th>
                                {{
                                  "MenListComponent.table.headers.action"
                                    | translate
                                }}
                              </th>
                            </tr>

                            <ng-template #sortIcons let-key="key">
                              <i
                                *ngIf="
                                  sortedField === key && sortOrder === 'ASC'
                                "
                                class="fa fa-sort-up ms-1 text-dark"
                              ></i>
                              <i
                                *ngIf="
                                  sortedField === key && sortOrder === 'DESC'
                                "
                                class="fa fa-sort-down ms-1 text-dark"
                              ></i>
                              <i
                                *ngIf="sortedField !== key"
                                class="fa fa-sort ms-1 text-muted"
                              ></i>
                            </ng-template>
                          </thead>
                          <tbody>
                            <tr *ngFor="let e of form.list; let i = index">
                              <td class="text-center">{{ pageIndex(i) }}</td>
                              <td>{{ e["name"] }}</td>
                              <td>{{ e["linkto"] }}</td>
                              <td>{{ e["applicationName"] | truncate }}</td>
                              <td>{{ e["formTitle"] | truncate }}</td>
                              <td>{{ e["reportsTitle"] | truncate }}</td>
                              <td>{{ e["url"] | truncate }}</td>
                              <td>
                                <div class="d-flex align-items-center">
                                  <!-- Edit Button -->
                                  <button
                                    mat-stroked-button
                                    [matTooltip]="
                                      'MenListComponent.table.actions.edit'
                                        | translate
                                    "
                                    class="icon-width me-2"
                                    color="primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop"
                                    (click)="get(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >edit</mat-icon
                                    >
                                  </button>

                                  <!-- Archive Button -->
                                  <button
                                    mat-stroked-button
                                    [matTooltip]="
                                      'MenListComponent.table.actions.archive'
                                        | translate
                                    "
                                    class="icon-width"
                                    color="primary"
                                    (click)="deleteMenu(e)"
                                  >
                                    <mat-icon
                                      class="icon-compact"
                                      style="transform: rotate(180deg)"
                                      >archive</mat-icon
                                    >
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <app-list-header [$parent]="getSelf()"></app-list-header>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="nav-new-previews"
                  role="tabpanel"
                  aria-labelledby="nav-new-previews-tab"
                  tabindex="0"
                >
                  <div class="mt-3">
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg-5">
                        <div id="sidebar">
                          <div class="d-flex g-3 mb-2">
                            <!-- Material Button for Expand -->
                            <button
                              mat-stroked-button
                              color="primary"
                              class="me-2"
                              (click)="toggleAllMenus(true)"
                            >
                              <mat-icon>add</mat-icon>
                              {{
                                "MenListComponent.roleManagement.expand"
                                  | translate
                              }}
                            </button>
                            <!-- Material Button for Collapse -->
                            <button
                              mat-stroked-button
                              color="primary"
                              (click)="toggleAllMenus(false)"
                            >
                              <mat-icon>remove</mat-icon>
                              {{
                                "MenListComponent.roleManagement.collapse"
                                  | translate
                              }}
                            </button>
                          </div>
                          <!-- Parent Item -->
                          <ul class="sidebar-nav">
                            <div
                              class="sidebar-item"
                              *ngFor="let node of nodes"
                              [attr.draggable]="true"
                              (dragstart)="onDragStart($event, node)"
                              (dragover)="onDragOver($event, node)"
                              (drop)="onDrop($event, node)"
                            >
                              <ng-container
                                *ngTemplateOutlet="
                                  tmplNode;
                                  context: { node: node, parent: null }
                                "
                              >
                              </ng-container>
                            </div>
                          </ul>

                          <ng-template
                            #tmplNode
                            let-node="node"
                            let-parent="parent"
                          >
                            <div
                              class="node-item sidebar-item"
                              [attr.data-id]="node.id"
                            >
                              <div class="sidebar-item node-title">
                                <a
                                  (click)="node.isExpanded = !node.isExpanded"
                                  class="d-flex align-items-center"
                                >
                                  <!-- Material Icons for different link types - Only text-primary class -->
                                  <mat-icon class="me-2 text-primary">
                                    {{
                                      node.linkto == "seperator"
                                        ? "horizontal_rule"
                                        : node.linkto == "report"
                                          ? "assessment"
                                          : node.linkto == "url"
                                            ? "link"
                                            : node.linkto == "form"
                                              ? "description"
                                              : "folder"
                                    }}
                                  </mat-icon>
                                  <span
                                    [ngClass]="
                                      node.children?.length === 0
                                        ? 'childColor'
                                        : ''
                                    "
                                    >{{ node.name }}</span
                                  >
                                  <!-- Material Icon for arrow - Only text-primary class -->
                                  <mat-icon
                                    *ngIf="
                                      !node.children ||
                                      node.children.length === 0
                                    "
                                    class="ms-auto cursor-pointer text-primary"
                                    (click)="
                                      !node.children ||
                                      node.children.length === 0
                                        ? unassignMenu(node)
                                        : null
                                    "
                                  >
                                    arrow_forward
                                  </mat-icon>
                                </a>
                              </div>

                              <!-- Child Nodes -->
                              <div
                                *ngIf="node.isExpanded && node.children?.length"
                                class="node-children"
                              >
                                <div
                                  *ngFor="let child of node.children"
                                  class="sidebar-item child-item"
                                  [attr.draggable]="true"
                                  (dragstart)="onDragStart($event, child, node)"
                                  (dragover)="onDragOver($event, node)"
                                  (drop)="onDrop($event, child)"
                                >
                                  <ng-container
                                    *ngTemplateOutlet="
                                      tmplNode;
                                      context: { node: child, parent: node }
                                    "
                                  ></ng-container>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>

                      <div class="col-12 col-md-6 col-lg-7">
                        <div class="row">
                          <div
                            class="d-flex gap-3 align-items-center justify-content-between compact-inputs dropdown-pd-none"
                          >
                            <h6>
                              {{
                                "MenListComponent.roleManagement.unassignMenu"
                                  | translate
                              }}
                            </h6>

                            <mat-form-field appearance="outline">
                              <mat-select
                                [(ngModel)]="appRoleform['roleId']"
                                (selectionChange)="getRoleMenu($event.value)"
                                name="roleId"
                                placeholder="{{
                                  'MenListComponent.roleManagement.selectRole'
                                    | translate
                                }}"
                              >
                                <mat-option [value]="undefined">
                                  {{
                                    "MenListComponent.roleManagement.selectRole"
                                      | translate
                                  }}
                                </mat-option>

                                <mat-option
                                  *ngFor="let e of appRoleList"
                                  [value]="e['id']"
                                >
                                  {{ e["name"] }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="list-group mt-3">
                          <div class="table-responsive">
                            <!-- Header Row -->
                            <div
                              class="list-group-item fw-bold role-list-item no-radius"
                            >
                              <div class="cell sno">
                                {{
                                  "MenListComponent.roleManagement.headers.sno"
                                    | translate
                                }}
                              </div>
                              <div class="cell menu">
                                {{
                                  "MenListComponent.roleManagement.headers.menu"
                                    | translate
                                }}
                              </div>
                              <div class="cell form">
                                {{
                                  "MenListComponent.roleManagement.headers.form"
                                    | translate
                                }}
                              </div>
                              <div class="cell action">
                                {{
                                  "MenListComponent.roleManagement.headers.action"
                                    | translate
                                }}
                              </div>
                            </div>
                            <!-- Data Rows -->
                            <ul class="list-group">
                              <li
                                class="list-group-item role-list-item no-radius"
                                *ngFor="
                                  let e of unassignMenuList;
                                  let i = index
                                "
                              >
                                <div class="cell sno" data-label="S.No">
                                  {{ pageIndex(i) }}
                                </div>
                                <div class="cell menu flex-min-zero">
                                  <span
                                    class="truncate-text"
                                    [attr.title]="e.name"
                                    >{{ e.name }}</span
                                  >
                                </div>
                                <div class="cell form flex-min-zero">
                                  <span
                                    class="truncate-text"
                                    [attr.title]="e.formTitle"
                                    >{{ e.formTitle }}</span
                                  >
                                </div>
                                <div class="cell action" data-label="Action">
                                  <mat-icon
                                    color="primary"
                                    class="cursor"
                                    (click)="assignMenu(e)"
                                    >arrow_back</mat-icon
                                  >
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              [class.show]="isProfileTabActive"
              [class.active]="isProfileTabActive"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div class="my-3">
                <div>
                  <p
                    *ngIf="
                      form['searchError'] == false && form['searchMessage']
                    "
                  >
                    <app-ncs-alert
                      [message]="form['searchMessage']"
                      type="success"
                    />
                  </p>
                  <p
                    *ngIf="form['searchError'] == true && form['searchMessage']"
                  >
                    <app-ncs-alert
                      [message]="form['searchMessage']"
                      type="danger"
                    />
                  </p>
                </div>

                <div class="table-container">
                  <div class="table-responsive">
                    <table class="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{
                              "MenListComponent.table.headers.sno" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.title" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.linkTo"
                                | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.application"
                                | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.api" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.form" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.report"
                                | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.url" | translate
                            }}
                          </th>
                          <th>
                            {{
                              "MenListComponent.table.headers.action"
                                | translate
                            }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let e of form['archivedlist']; let i = index"
                        >
                          <td class="text-center">{{ pageIndex(i) }}</td>
                          <td>{{ e["name"] }}</td>
                          <td>{{ e["linkto"] }}</td>
                          <td>{{ e["applicationName"] | truncate }}</td>
                          <td>{{ e["userstoryId"] }}</td>
                          <td>{{ e["formId"] | truncate }}</td>
                          <td>{{ e["reportsId"] | truncate }}</td>
                          <td>{{ e["url"] | truncate }}</td>
                          <td>
                            <div
                              class="d-flex align-items-center justify-content-start p-0 m-0"
                            >
                              <button
                                [title]="
                                  'MenListComponent.table.actions.retrieve'
                                    | translate
                                "
                                class="btn btn-sm btn-outline-success sm-btn p-1"
                                (click)="retrieve(e.id)"
                              >
                                <i class="bx bx-archive-out p-0"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <app-list-header [$parent]="getSelf()"></app-list-header>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<div
  class="modal fade"
  id="staticBackdrop"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">
          {{ "MenListComponent.modal.title" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form #uiForm="ngForm">
          <!-- Alert Messages -->
          <div *ngIf="form['error'] == false && form['message']" class="mb-3">
            <app-ncs-alert
              [message]="form['message']"
              type="success"
            ></app-ncs-alert>
          </div>
          <div *ngIf="form['error'] == true && form['message']" class="mb-3">
            <app-ncs-alert
              [message]="form['message']"
              type="danger"
            ></app-ncs-alert>
          </div>

          <div class="compact-inputs dropdown-pd-none">
            <!-- Title -->
            <div class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.title" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <input
                  matInput
                  [(ngModel)]="form.data['name']"
                  type="text"
                  required
                  id="name"
                  name="name"
                  [placeholder]="
                    'MenListComponent.modal.placeholders.title' | translate
                  "
                />
              </mat-form-field>
            </div>

            <!-- Link To -->
            <div class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.linkTo" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <mat-select
                  required
                  [(ngModel)]="form.data['linkto']"
                  name="linkto"
                  [placeholder]="
                    'MenListComponent.modal.placeholders.type' | translate
                  "
                >
                  <mat-option [value]="null" disabled>
                    {{ "MenListComponent.modal.placeholders.type" | translate }}
                  </mat-option>
                  <mat-option value="form">{{
                    "MenListComponent.search.types.form" | translate
                  }}</mat-option>
                  <mat-option value="report">{{
                    "MenListComponent.search.types.report" | translate
                  }}</mat-option>
                  <mat-option value="url">{{
                    "MenListComponent.search.types.url" | translate
                  }}</mat-option>
                  <mat-option value="seperator">{{
                    "MenListComponent.search.types.seperator" | translate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- API Usecase for Form -->
            <div *ngIf="form.data['linkto'] === 'form'" class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.apiUsecase" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <mat-select
                  required
                  [(ngModel)]="form.data['userstoryId']"
                  name="userstoryId"
                  (selectionChange)="getFormList(form.data['userstoryId'])"
                  placeholder="{{
                    'MenListComponent.modal.placeholders.usecase' | translate
                  }}"
                >
                  <mat-option value="undefined" disabled>{{
                    "MenListComponent.modal.placeholders.usecase" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of usecases" [value]="e['id']">{{
                    e["name"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- API Usecase for Report -->
            <div *ngIf="form.data['linkto'] === 'report'" class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.apiUsecase" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <mat-select
                  required
                  [(ngModel)]="form.data['userstoryId']"
                  name="userstoryId"
                  (selectionChange)="getReport(form.data['userstoryId'])"
                  placeholder="{{
                    'MenListComponent.modal.placeholders.usecase' | translate
                  }}"
                >
                  <mat-option value="undefined" disabled>{{
                    "MenListComponent.modal.placeholders.usecase" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of usecases" [value]="e['id']">{{
                    e["name"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Form Selection -->
            <div *ngIf="form.data['linkto'] === 'form'" class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.form" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <mat-select
                  required
                  [(ngModel)]="form.data['formId']"
                  name="formId"
                  (selectionChange)="onFormChange(form.data['formId'])"
                  [placeholder]="
                    'MenListComponent.modal.placeholders.form' | translate
                  "
                >
                  <mat-option value="undefined" disabled>{{
                    "MenListComponent.modal.placeholders.form" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of forms" [value]="e['id']">{{
                    e["title"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Report Selection -->
            <div *ngIf="form.data['linkto'] === 'report'" class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.report" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <mat-select
                  required
                  [(ngModel)]="form.data['reportsId']"
                  name="reportsId"
                  placeholder="{{
                    'MenListComponent.modal.placeholders.report' | translate
                  }}"
                >
                  <mat-option value="undefined" disabled>{{
                    "MenListComponent.modal.placeholders.report" | translate
                  }}</mat-option>
                  <mat-option *ngFor="let e of reportlist" [value]="e['id']">{{
                    e["title"]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- URL Input -->
            <div *ngIf="form.data['linkto'] === 'url'" class="mb-3">
              <mat-label class="mb-1 d-block"
                >{{ "MenListComponent.modal.labels.url" | translate
                }}<span class="text-danger">*</span></mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100"
                hideRequiredMarker
              >
                <input
                  matInput
                  [(ngModel)]="form.data['url']"
                  type="text"
                  required
                  id="url"
                  name="url"
                  [placeholder]="
                    'MenListComponent.modal.placeholders.url' | translate
                  "
                />
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="d-flex gap-2 justify-content-end">
          <!-- Save Button -->
          <button
            mat-stroked-button
            color="primary"
            type="button"
            data-bs-dismiss="modal"
            [disabled]="!uiForm.valid"
            (click)="save()"
          >
            <mat-icon>save</mat-icon>
            {{ "MenListComponent.modal.buttons.save" | translate }}
          </button>
          <!-- Close Button -->
          <button
            mat-stroked-button
            color="warn"
            type="button"
            data-bs-dismiss="modal"
          >
            <mat-icon>close</mat-icon>
            {{ "MenListComponent.modal.buttons.close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>